export default __webpack_public_path__ + "static/爱可生-9b97244ade9c23c8ec27efb5ffa3e23e.png";